import type { SxProps, Theme } from '@mui/material/styles';

export const ENABLE_SECURITY_DEBUG = false && process.env.NODE_ENV === 'development';

export const SECURITY_ACTIONS = {
    READ: 'READ',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    COMMENT: 'COMMENT',
    SHARE: 'SHARE',
    ACTIVATE: 'ACTIVATE',
    INACTIVATE: 'INACTIVATE'
} as const;

export const FEATURE_SECURITY_PERMISSIONS = {
    READ: 'Read',
    ANNOTATE: 'Annotate',
    MANAGE: 'Manage'
} as const;

export const ENTITY_SECURITY_PERMISSIONS = {
    READ: 'Read',
    EDIT: 'Edit',
    DELETE: 'Delete',
    COMMENT: 'Comment',
    SHARE: 'Share',
    ACTIVATE: 'Activate',
    INACTIVATE: 'Inactivate'
} as const;

export const SECURED_DISABLED_SX: SxProps<Theme> = {
    pointerEvents: 'none',
    opacity: 0.6
};
